import { Navigate, useLocation } from 'react-router-dom';

/**
 * The office app used to live at the root (/projects/…, /time-entries, /admin/…)
 * before the /office + /field split. Forward those paths so existing bookmarks,
 * pinned tabs and shared links keep working. Safe to delete once they've aged
 * out.
 */
export default function LegacyOfficeRedirect() {
    const location = useLocation();
    return (
        <Navigate
            to={`/office${location.pathname}${location.search}`}
            replace
        />
    );
}
